export default {
  FETCH_NEWSLETTER_STATS_REQUEST: 'FETCH_NEWSLETTER_STATS_REQUEST',
  FETCH_NEWSLETTER_STATS_SUCCESS: 'FETCH_NEWSLETTER_STATS_SUCCESS',
  FETCH_NEWSLETTER_STATS_FAILURE: 'FETCH_NEWSLETTER_STATS_FAILURE'
}
